export default __webpack_public_path__ + "static/media/WelcomePageStep1.33dcaf98.png";